import Dropdown from '@/classes/Dropdown';

document.addEventListener('DOMContentLoaded', () => {
    new Dropdown(document.querySelector('.dropdown'));
});
